<template>
  <div>
    <div class="randomiser-container">
      <div></div>
      <div class="randomizer-center-column">
        <label class="typo__label"><b>{{ value.length }}</b> player/s selected</label>
        <MultiSelect v-model="value" ref="multiSelectContainer" tag-placeholder="Add this as new player"
          placeholder="Search or add a player" label="fullName" track-by="_id" :options="listOfPlayerNames"
          :multiple="true" :closeOnSelect="false" :tagPosition="'bottom'" :taggable="true" @tag="addTag"></MultiSelect>
        <button @click="randomisePlayerList" class="button-6 randomise-button">
          <font-awesome-icon icon="fa fa-shuffle" class="shuffle-icon" />
        </button>
        <div class="randomise-count">
          {{ `Randomised ` }}
          <span><strong>{{ randomCount }}</strong></span>
          {{ ` ${randomCount === 1 ? "time" : "times"} so far` }}
        </div>
      </div>
      <div class="randomiser-right-column">
        <button class="button-6 switch-randomiser-button" @click="toggleRandomiserMode">
          <font-awesome-icon icon="fa fa-table-list" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "vue-multiselect";
import { mapGetters, mapState, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";

export default {
  components: {
    MultiSelect,
  },
  data() {
    return {
      value: [],
      randomCount: 0,
    };
  },
  computed: {
    ...mapState(["listOfPlayerNames"]),
    ...mapGetters(["getFilledSeats"]),
    playerCount() {
      return this.value.length;
    }
  },
  methods: {
    ...mapActions(["setPlayerNames", "toggleRandomiserMode"]),
    randomisePlayerList() {
      const finalList = _.shuffle(
        this.value.map((x) => x.displayName).filter((x) => x !== "")
      );
      const players = new Array(this.getFilledSeats);
      let pointer = 0;

      finalList.forEach((x) => {
        pointer = pointer % this.getFilledSeats;
        players[pointer] = players[pointer] ? `${players[pointer]}+${x}` : x;
        pointer++;
      });
      this.setPlayerNames(_.shuffle(players.map((x) => x.slice(0, 50))));
      this.randomCount++;
    },

    addTag(newTag) {
      const tag = {
        displayName: newTag,
        playerName: newTag,
        fullName: `${newTag} (${newTag})`,
        _id: uuidv4(),
      };

      this.value.push(tag);
    },
  },
};
</script>

<style lang="css">
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.randomiser-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
}

.randomiser-right-column {
  text-align: left;
  padding: 20px;
  margin-top: 100px;
}

.typo__label {
  font-size: 18px;
}

.multiselect {
  margin-top: 20px;
}

.multiselect__tag {
  background-color: blanchedalmond;
  color: black;
  font-size: 16px;
}

.multiselect__tag-icon:hover {
  background-color: rgb(104, 97, 87);
  color: white;
}

.randomise-button {
  margin-top: 25px;
  margin-bottom: 15px;
}

.shuffle-icon {
  color: #666666;
}

.button-6 {
  align-items: center;
  background-color: #cccccc;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  cursor: pointer;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 24px;
  justify-content: center;
  line-height: 24px;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
}

.button-6:hover:not([disabled]),
.button-6:focus:not([disabled]) {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover:not([disabled]) {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.button-6:disabled {
  background-color: #eeeeee;
  color: #888888;
}

.switch-randomiser-button {
  color: #666666;
}
</style>